import * as React from 'react';

export default () => (
    <div className="tab-content dashboardtab-content" id="myTabContent">

        <div
            className="tab-pane fade wrapleft  wrapright-sec  mar-top-35 mobo-padding"
            id="Billing"
            role="tabpanel"
            aria-labelledby="contact-tab">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-lg-12 breadcrumb-col">
                        <ul>
                            <li>
                                <a href="#">Dashboard</a>
                            </li>
                            <li>
                                <i className="fas fa-angle-right" />
                            </li>
                            <li>Billing </li>
                        </ul>
                    </div>
                    <div className="col-lg-12 pagetitle">
                        <h2>Billing</h2>
                        <p>Dummy text to explain what happens on the Messages tab</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
);



// WEBPACK FOOTER //
// ./src/client/dashboard/Template.tsx